import React from "react";
import { useSelector } from "react-redux";

const RoundLockIcon = ({ color }) => {
  // PASS HEX CODE FOR COLOR WITHOUT HASHTAG(#)

  // FETCHING STATES FROM REDUCER
  const appAccentColor = useSelector(
    (state) => state?.persistedDataReducer?.appAccent
  );

  return (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 31.4994C0 14.1032 14.1028 0 31.4989 0C48.8951 0 62.999 14.1032 62.999 31.4994C62.999 48.8949 48.8951 62.9987 31.4989 62.9987C14.1028 62.9987 0 48.8951 0 31.4994ZM28.5996 36.9139C28.5996 35.3043 29.9045 34 31.5135 34C33.1227 34 34.4274 35.3043 34.4274 36.9139C34.4274 37.9929 33.8392 38.933 32.9671 39.4368V42.6763H30.0599V39.4368C29.1879 38.9328 28.5996 37.9929 28.5996 36.9139ZM31.4415 21.2002C28.9922 21.2002 27 23.1926 27 25.6417V30.3716H35.8826V25.6417C35.8824 23.1929 33.8902 21.2002 31.4415 21.2002ZM23.8793 45.5H38.9363C40.5264 45.5 41.8156 44.2019 41.8156 42.6006H41.8153V33.2393C41.8153 31.8428 40.834 30.6773 39.5283 30.4022V26.1759C39.5283 21.6676 35.8855 18 31.4081 18C26.9303 18 23.2875 21.668 23.2875 26.1759V30.4022C21.9813 30.6765 21 31.8428 21 33.2393V42.6006C21 44.202 22.2892 45.5 23.8793 45.5Z"
        fill={`#${color?.replace("#", "") || appAccentColor}`}
      />
    </svg>
  );
};

export default RoundLockIcon;
